import {
  ReportCluster,
  Reports,
} from 'src/app/core/enums/role-permissions.enum';
import { AgedRetailStatus } from 'src/app/core/models/reports/reports.model';

export const CONSTS = {
  HEADER: $localize`Reports`,
};

export type ReportButton = {
  text: string;
  enum?: Reports;
  downloadOnly: boolean;
  hasArrowIcon?: boolean;
};

export type ReportGroup = {
  header: string;
  buttons: ReportButton[];
  hasAltSpacing: boolean;
  enum: ReportCluster;
};

//REPORT GROUPS//////////////////////////////////////
export const ONROAD_OPERATIONS: ReportGroup = {
  header: $localize`On-Road Operations`,
  buttons: [
    {
      text: $localize`Driver Load Report`,
      enum: Reports.DRIVER_LOAD_REPORT,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Delivery Manifest`,
      enum: Reports.DELIVERY_MANIFEST,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Pickup Manifest`,
      enum: Reports.PICKUP_MANIFEST,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Load Discrepancy Report`,
      enum: Reports.LOAD_DISCREPANCY_REPORT,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Send Again`,
      enum: Reports.SEND_AGAIN,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Dry Ice`,
      enum: Reports.DRY_ICE,
      downloadOnly: false,
      hasArrowIcon: true,
    },
  ],
  hasAltSpacing: false,
  enum: ReportCluster.ONROAD_OPERATIONS,
};

export const CODS: ReportGroup = {
  header: $localize`CODs`,
  buttons: [
    {
      text: $localize`Group COD Extract`,
      enum: Reports.GROUP_COD_EXTRACT,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`COD Out for Delivery`,
      enum: Reports.COD_OUT_FOR_DELIVERY,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`COD Reconcile`,
      enum: Reports.COD_RECONCILE,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`COD Reconcile Report`,
      enum: Reports.COD_RECONCILE_REPORT,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`COD Collected/Cleared`,
      enum: Reports.COD_COLLECTED_CLEARED,
      downloadOnly: false,
      hasArrowIcon: true,
    },
  ],
  hasAltSpacing: false,
  enum: ReportCluster.CODS,
};

export const EXCEPTIONS: ReportGroup = {
  header: $localize`Exceptions Reports`,
  buttons: [
    {
      text: $localize`Handover Scan Report`,
      enum: Reports.HANDOVER_SCAN_REPORT,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Exception Processing Report`,
      enum: Reports.EXCEPTION_PROCESSING_REPORT,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Building Scan Export`,
      enum: Reports.BUILDING_SCAN_EXPORT,
      downloadOnly: false,
      hasArrowIcon: true,
    },
  ],
  hasAltSpacing: false,
  enum: ReportCluster.EXCEPTIONS_REPORTS,
};

export const SUMMARIES: ReportGroup = {
  header: $localize`Summaries`,
  buttons: [
    {
      text: $localize`Location Summary`,
      enum: Reports.LOCATION_SUMMARY,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Group Summary`,
      enum: Reports.GROUP_SUMMARY,
      downloadOnly: false,
      hasArrowIcon: true,
    },
  ],
  hasAltSpacing: false,
  enum: ReportCluster.SUMMARIES,
};

export const INVENTORY: ReportGroup = {
  header: $localize`Inventory`,
  buttons: [
    {
      text: $localize`Location Inventory Report`,
      enum: Reports.LOCATION_INVENTORY,
      downloadOnly: true,
    },
    {
      text: $localize`Group Inventory Report`,
      enum: Reports.GROUP_INVENTORY,
      downloadOnly: true,
    },
  ],
  hasAltSpacing: false,
  enum: ReportCluster.INVENTORY,
};

export const ERRORS: ReportGroup = {
  header: $localize`Errors`,
  buttons: [
    {
      text: $localize`Location Error Report`,
      enum: Reports.LOCATION_ERROR_REPORT,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Group Error Report`,
      enum: Reports.GROUP_ERROR_REPORT,
      downloadOnly: false,
      hasArrowIcon: true,
    },
  ],
  hasAltSpacing: false,
  enum: ReportCluster.ERRORS,
};

export const OTHER: ReportGroup = {
  header: $localize`Other`,
  buttons: [
    {
      text: $localize`Aged Package Status`,
      enum: Reports.AGED_PACKAGE_STATUS,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Retail Activity Report`,
      enum: Reports.RETAIL_ACTIVITY_REPORT,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Non-UPS Barcode Extract`,
      enum: Reports.NON_UPS_BARCODE_EXTRACT,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Aged Retail Status Report`,
      enum: Reports.AGED_RETAIL_STATUS,
      downloadOnly: true,
    },
    {
      text: $localize`Package Not Found`,
      enum: Reports.PACKAGE_NOT_FOUND,
      downloadOnly: true,
    },
  ],
  hasAltSpacing: true,
  enum: ReportCluster.OTHER,
};

export const IDO: ReportGroup = {
  header: $localize`IDO`,
  buttons: [
    {
      text: $localize`Location Forecast vs. Actual`,
      enum: Reports.LOCATION_FORECAST,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Group Forecast vs. Actual`,
      enum: Reports.GROUP_FORECAST,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Location EDW Summary`,
      enum: Reports.LOCATION_EDW,
      downloadOnly: false,
      hasArrowIcon: true,
    },
    {
      text: $localize`Group EDW Summary`,
      enum: Reports.GROUP_EDW,
      downloadOnly: false,
      hasArrowIcon: true,
    },
  ],
  hasAltSpacing: true,
  enum: ReportCluster.IDO,
};
////////////////////////////////////////////////

export const REPORT_BUTTON_GROUPS: ReportGroup[][] = [
  [ONROAD_OPERATIONS, CODS, EXCEPTIONS, SUMMARIES],
  [INVENTORY, ERRORS, OTHER, IDO],
];

export const MOCK_ROUTES = [
  {
    label: 'All',
    value: 'All',
  },
  {
    label: 'Route 1',
    value: 'Route 1',
  },
  {
    label: 'Route 2',
    value: 'Route 2',
  },
  {
    label: 'Route 3',
    value: 'Route 3',
  },
  {
    label: 'Route 4',
    value: 'Route 4',
  },
  {
    label: 'Route 5',
    value: 'Route 5',
  },
  {
    label: 'Route 6',
    value: 'Route 6',
  },
];

export const AGED_RETAIL_STATUS_PDF_REPORT = {
  NAME: $localize`RETAIL INVENTORY`,
  COLUMNS: [
    $localize`Return to Ups`.toUpperCase(),
    $localize`Trackno`.toUpperCase(),
    $localize`Event`.toUpperCase(),
    $localize`Time`.toUpperCase(),
  ],
  DATA_FIELDS: [
    'returnToUps',
    'trackno',
    'event',
    'time',
  ] as (keyof AgedRetailStatus)[],
};
